<template>
  <div>
    <div class="gooddetail">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for=" item in swipeImgUrl" v-bind:key="item">
          <van-image lazy-load height="300px" fit="contain" width="100%" :src="item" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="specification">
      <div class="detail-title">
        {{datailData.GoodsName}}
      </div>
      <div class="detail-desc">
        {{datailData.GoodsDesc}}
      </div>
      <div class="min-price">￥ {{datailData.UnitPrice}} / {{datailData.Unit}}</div>
    </div>
    <van-divider contentPosition="center" fontSize="20" textColor="rgba(69, 90, 100, 0.6)">详细信息</van-divider>
    <van-image v-for="item in detailImgUrl" :key="item" lazy-load fit="contain" width="100%" :src="item"></van-image>
    <van-goods-action>
      <!-- <van-goods-action-icon icon="cart-o" text="购物车" @click="ViewCart" />   -->
      <van-goods-action-button type="warning" text="加入购物车" @click="onAddCart" />
      <van-goods-action-button type="danger" text="立即购买" @click="onAddCart" />
    </van-goods-action>

    <van-sku
        v-model="show"
        :sku="sku"
        :goods="goods"
        :goods-id="goodsId"
        :hide-stock="sku.hide_stock"
        :show-add-cart-btn="buyMode==0"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked">
      <!-- <template slot="sku-actions">
        <div class="van-sku-actions">
          <van-button square size="large" type="warning" @click="onAddCartClicked">
            确定
          </van-button>
        </div>
      </template> -->
    </van-sku>

  </div>
</template>

<script>
import { Button, Sku, Swipe, SwipeItem } from "vant";
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from "vant";
import { Divider } from "vant";
import { debug } from 'util';
export default {
  name: "",
  data() {
    return {
      swipeImgUrl: [],
      detailImgUrl: [],
      datailData: {},
      show: false,
      goodsId: 0,
      buyMode:0,
      sku: {
        // 数据结构见下方文档
      },
      goods: {
        // 数据结构见下方文档
      },
    };
  },
  methods: {
    /*加入购物车 old */
    // AddToCart() {
    //   var id = this.datailData.ID;
    //   if (!this.$store.state.isLogin) {
    //     this.$store.commit("showLogin");
    //     return;
    //   } else {
    //     var that = this;
    //     this.$http.get("Order/AddGoodsToCart?id=" + id).then((res) => {
    //       that.$http.get("Order/GetCartCount").then((res2) => {
    //         that.$toast.clear();
    //         that.$toast.success("添加成功");
    //         that.$store.commit("setCartCount", res2.data.Data);
    //       });
    //     });
    //   }
    // },
    /*立即购买 old */
    // Submit() {
    //   var id = this.datailData.ID;
    //   if (!this.$store.state.isLogin) {
    //     this.$store.commit("showLogin");
    //     return;
    //   } else {
    //     var that = this;
    //     this.$http.get("Order/AddGoodsToCart?id=" + id).then((res) => {
    //       that.$router.push({
    //         name: "Cart"            
    //       });
    //     });
    //   }
    // },
    /*商品详情 加入购物车 */
    onAddCart(){
      this.show = true;
    },
    /*选择规格 立即购买 */
    onBuyClicked(skuData){
      if (!this.$store.state.isLogin) {
        this.$store.commit("showLogin");
        return;
      }
      this.$router.push({
        name: "Confirm",
        params: { 
          product_id: skuData.goodsId, 
          sku_id: skuData.selectedSkuComb.id, 
          count: skuData.selectedNum
        },
      });
    },
    /*选择规格 加入购物车 */
    onAddCartClicked(skuData) {
      if (!this.$store.state.isLogin) {
        this.$store.commit("showLogin");
        return;
      }
      if (!skuData.selectedSkuComb.id) {
          this.$toast("请选择规格~");
      } else {
        if (skuData.selectedSkuComb.stock_num < skuData.selectedNum) {
          this.$toast("库存不足,请修改数量~");
          return;
        }
        var data = {
          sku_id: skuData.selectedSkuComb.id,
          count: skuData.selectedNum
        }
        this.$http.get("Order/AddGoodsCart?skuid="+data.sku_id+"&count="+data.count).then((res) => {
          if(res.data=="success"){
            this.$toast("成功添加到购物车~");
            this.show=false;
          }else{
            this.$toast.fail(res.data);   
          }
        });
      }
    },
    /*查询商品详细 */
    GetGoodDetail(){
      var that = this;
      this.$http
        .get("Order/GetGoodsById?id=" + that.goodsId)
        .then((res) => {
          that.$toast.clear();
          var goodsImgArary = res.data.Data.GoodsImg.split(",");
          that.swipeImgUrl = goodsImgArary.map((item) => {
            return (
              that.$file.url +
              "Images/Mall/GoodsImg/" +
              res.data.Data.GoodsCode +
              "/" +
              item
            );
          });

          var goodsDetailArray = res.data.Data.GoodsDetailImg.split(",");
          that.detailImgUrl = goodsDetailArray.map((item) => {
            return (
              that.$file.url +
              "Images/Mall/GoodsImg/" +
              res.data.Data.GoodsCode +
              "/" +
              item
            );
          });

          that.datailData = res.data.Data;
        });
    },
    /*查询商品规格 */
    GetGoodSku(){
      this.$http
      .get("Goods/GetSpecByGood?goodsId=" + this.goodsId)
      .then((res) => {
        if(res.data.Msg=="success"){
          var data = res.data.Data;
          this.sku = {
            tree: data.speclist,
            list: data.skulist,
          //   list: [
          //   {
          //     id: 1, // skuId
          //     1: '1', // 规格类目 k_s 为 s1 的对应规格值 id
          //     2: '3', // 规格类目 k_s 为 s2 的对应规格值 id
          //     price: 100, // 价格（单位分）
          //     stock_num: 48 // 当前 sku 组合对应的库存
          //   },
          // ],
            price: data.goods.UnitPrice,     // 默认价格（单位元）
            stock_num: data.goods.TotalStock,   // 商品总库存
            collection_id: 0, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
            none_sku: false,  // 是否无规格商品
            hide_stock: false // 是否隐藏剩余库存
          }
          this.goods = {
             // 默认商品 sku 缩略图
             picture: this.$file.url +
              "Images/Mall/GoodsImg/" +
              data.goods.GoodsCode +
              "/" +
              data.goods.GoodsImg.split(",")[0]
          }
        }
      });
    },
    // ViewCart(){

    // }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Divider.name]: Divider,
    [Sku.name]: Sku,
    [Button.name]: Button,
  },
  created() {
    this.goodsId = this.$route.params.id;
    this.GetGoodDetail();
    this.GetGoodSku();
  },
};
</script>

<style>
.detail-swipe .van-swipe-item {
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}
.detail-title {
  font-size: 13px;
  padding-top: 6px;
  color: #4a4949;
}
.specification {
  margin-top: 5px;
  /* margin-top: 10px; */
  background: #ffffff;
  padding: 3px 10px 10px 10px;
  line-height: 26px;
  color: #9d9d9d;
  text-align: left;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.detail-desc {
  /* color: #c7c7c7; */
  line-height: 22px;
  font-size: 10px;
}
.min-price {
  color: #fb3939;
  font-size: 14px;
  padding-right: 10px;
}
.van-goods-action {
  bottom: 51px;
  /* position:relative; */
}
div{
  text-align: left;
}
.van-sku-actions{
  margin-bottom: 60px;
}
</style>